import type { TranslatedString } from '@stamhoofd/structures';
import type { ErrorBox } from '../errors/ErrorBox';

/** Props for the responsive save/delete form container; button placement follows the device's platform conventions. */
export type SaveViewProps = {
    loading?: boolean;
    loadingView?: boolean;
    errorBox?: ErrorBox | null;
    deleting?: boolean;
    disabled?: boolean;
    title?: string | TranslatedString;
    saveText?: string;
    saveIcon?: string | null;
    saveButtonClass?: string | null;
    /** Temporarily disables the save button for this many ms (e.g. to slow down a destructive action) */
    availabilityDelay?: number;
    saveIconRight?: string | null;
    saveIconMobile?: string | null;
    saveBadge?: string | number | null;
    cancelText?: string | null;
    preferLargeButton?: boolean;
    addExtraCancel?: boolean;
    mainClass?: string;
    /** Hides the toolbar at the bottom, for a view that shows its save button somewhere else (e.g. in the actions of a PreviewPanel) */
    hideToolbar?: boolean;
};

export const SaveViewDefaults = {
    loading: false,
    loadingView: false,
    errorBox: null,
    deleting: false,
    disabled: false,
    title: '',
    saveText: () => $t(`%1Op`),
    saveIcon: null,
    saveButtonClass: 'primary',
    saveIconRight: null,
    saveIconMobile: null,
    saveBadge: null,
    cancelText: () => $t(`%1Lh`),
    preferLargeButton: false,
    addExtraCancel: false,
    mainClass: '',
    hideToolbar: false,
};
